import React, { useState, useEffect, useReducer } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  Panel,
  Row,
  Table,
  ButtonGroup,
  Message,
  IconButton,
  Icon,
  Button,
  Col,
  DatePicker,
  Form,
} from 'rsuite'
import {
  getContractAttachment,
  updateCheckAttachments,
  getDownloadAttachmentGrantee,
  getDownloadContractPdf,
  getDownloadContractPdfRealtime,
  getDownloadProposalPdfRealtime,
  contractRequest,
  getSendFileToESignPage,
  updateSendFileToESign,
} from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { DATE_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, requiredFiled, getMaxLengthData } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import moment from 'moment'
import notification from '../../utils/notification'
import { ERR_MSG, RETRY_CONTACT_ADMIN, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { downloadFileByPath } from '../../redux/actions/accountingAssetClosure'

export default function ReSendFilesContractWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { isContractCenter, isContractFile, isShowButtonMakeContract } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [schema, setSchema] = useState(props.schema)
  const [isError, setIsError] = useState(false)
  const [isSucceed, setIsSucceed] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [fileId, setFileId] = useState(false)
  const [fileName, setFileName] = useState()
  const [filePath, setFilePath] = useState()

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    setTimeout(() => {
      forceUpdate()
    }, 100)
  }, [schema])

  const callGetDownloadService = async (fileObj, type) => {
    startLoading()
    try {
      let file = await downloadFileByPath(fileObj.filePath)

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      if (type == 'download') {
        link.setAttribute('download', fileObj.fileName)
      } else {
        link.target = '_blank'
        link.setAttribute('value', fileObj.fileName)
      }

      document.body.appendChild(link)
      setIsError()
      link.click()
    } catch (e) {
      if (type == 'download') {
        setIsError('ดาวน์โหลดไม่สำเร็จ ' + e?.response?.status + ' ' + e?.response?.statusText)
      } else {
        setIsError('แสดงไม่สำเร็จ ' + e?.response?.status + ' ' + e?.response?.statusText)
      }
    }
    doneLoading()
  }

  const onDownload = (fileObj) => {
    callGetDownloadService(fileObj, 'download')
  }

  const onPreview = (fileObj) => {
    callGetDownloadService(fileObj, 'preview')
  }

  const handleCallService = async () => {
    // console.log('req555522 => ', request)
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      let request = {
        fileName: fileName,
        filePath: filePath,
      }
      const response = await updateSendFileToESign(projectId, request)

      if (response.success) {
        notification.open('success', {
          title: 'ส่งสำเร็จ',
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response.message || `${ERR_MSG} ${RETRY_CONTACT_ADMIN}`,
        })
      }
      setShowConfirm(false)
      setIsError(false)
      const res = await getSendFileToESignPage(projectId)
      if (res.success) {
        setSchema(res?.model?.forms?.contractFilesToESign)
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || `${ERR_MSG} ${RETRY_CONTACT_ADMIN}`,
      })
      setShowConfirm(false)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnClickReSendFile = (rowData) => {
    setFileId(rowData.id)
    setFileName(rowData.fileName)
    setFilePath(rowData.filePath)
    setShowConfirm(true)
  }

  const handleSubmitContract = async (data) => {
    console.log('handleSubmitContract ', data)

    setIsLoading(true)
    startLoading()
    setIsError(false)
    setIsSucceed(false)

    const request = {
      // contractDate: moment(data.contractDate, 'DD/MM/YYYY').toDate(),
      contractDate: moment(data.contractDate, 'DD/MM/YYYY').toDate().toLocaleDateString('en-ZA'),
    }

    console.log('request request ', request)

    try {
      const response = await contractRequest(request, projectId)
      if (response.success) {
        setIsError(false)
        setIsSucceed(true)
        setSchema(response?.model?.forms?.contractFile)
      }
    } catch (e) {
      console.error(e)
      setIsError(e?.response?.data?.errorMessage)
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <Panel
      shaded
      header={schema.header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: 10 }}
    >
      <Row style={{ marginBottom: 10 }}>
        {isError && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="error" description={isError} />
          </Row>
        )}

        <Table
          autoHeight
          height={300}
          // height={400}
          // autoHeight={schema?.attachFiles?.value?.length <= 6}
          wordWrap
          bordered
          data={
            schema?.values?.filter((item) => item.filePath) || []
            //: schema?.attachFiles?.value || []
          }
        >
          <Column width={70} align="center" fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          {!isContractFile && (
            <Column width={300}>
              <HeaderCell>ประเภทเอกสาร</HeaderCell>
              <Cell dataKey="masterContractFileName" />
            </Column>
          )}
          <Column minWidth={150} flexGrow={1}>
            <HeaderCell>ชื่อเอกสาร</HeaderCell>
            <Cell dataKey="fileName" />
          </Column>

          {!isContractFile && (
            <Column width={100}>
              <HeaderCell>สถานะ</HeaderCell>
              <Cell dataKey="sendStatusName" />
            </Column>
          )}

          <Column width={103} fixed="right">
            <HeaderCell></HeaderCell>
            <Cell style={{ marginRight: 20 }}>
              {(rowData) => {
                return (
                  <ButtonGroup>
                    <TooltipButton
                      icon="eye"
                      tooltip={`แสดง`}
                      onClick={(e) => onPreview(rowData)}
                    ></TooltipButton>
                    <TooltipButton
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      onClick={(e) => onDownload(rowData)}
                    ></TooltipButton>
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>

          {isContractCenter && (
            <Column width={210} fixed="right">
              <HeaderCell></HeaderCell>
              <Cell style={{ marginRight: 20 }}>
                {(rowData) => {
                  if (rowData.sendStatus == 1) {
                    return
                  }
                  return (
                    <IconButton
                      icon={
                        <Icon
                          icon="send"
                          //style={{ color: rowData.isChecked ? '#14997a' : '#8e8e93' }}
                        />
                      }
                      onClick={(e) => handleOnClickReSendFile(rowData)}
                    >
                      ส่งไฟล์ใหม่
                    </IconButton>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </Row>

      <ConfirmWidget
        size={'sm'}
        title={`ส่งไฟล์ใหม่`}
        show={showConfirm}
        detail={`ยืนยันการส่งไฟล์ใหม่อีกครั้งไปยังระบบ e-signature`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </Panel>
  )
}
